import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {CardActions as RmwcCardActions} from '@rmwc/card'
import '@rmwc/card/styles'

const StyledRmwcCardActions = styled(RmwcCardActions)`
  &&& {
    padding: 0;
  }
`

const CardActions = ({children, ...otherProps}) => <StyledRmwcCardActions {...otherProps}>{children}</StyledRmwcCardActions>

CardActions.propTypes = {
  children: PropTypes.any,
  fullBleed: PropTypes.bool
}

export {CardActions}
